export const initializeBanners = () => {
  const headlineElem = document.querySelector('.headline-ad');
  const catfishElem = document.querySelector('.catfish-ad');
  const bottomNavbar = document.querySelector('.bottom-navbar');
  const hotLineElem = document.querySelector('.hot-line-wrapper');

  if (!headlineElem || !catfishElem || !bottomNavbar) {
    return
  }

  let rafPending = false;
  let navbarClassesAdded = false;

  const handleScroll = () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScroll > 860) {
      headlineElem.classList.add('headline-ad_active');
      if (!navbarClassesAdded) {
        catfishElem?.classList.add('catfish-ad_active');
        if (bottomNavbar?.classList.contains('bottom-navbar_opened')) {
          bottomNavbar?.classList.add('bottom-navbar_opened-with-cookies');
        }
        if(hotLineElem && !hotLineElem.classList.contains('hot-line-wrapper_closed')) {
          headlineElem.classList.add('headline-ad_with_hotline');
        }
      }
      navbarClassesAdded = true
    } else {
      headlineElem?.classList.remove('headline-ad_active');
    }

    rafPending = false;
  };

  window.addEventListener('scroll', () => {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(handleScroll);
    }
  });
}